module.exports = __webpack_public_path__ + "static/img/taian-index.67df67c6.jpg";